import type { LocationObject } from 'src/app/views/pages/MultiLocation/type';

export const getSubTotal = (locations: LocationObject) => {
  let subTotal = 0;
  const locationObjects = Object.values(locations);

  for (const locationObject of locationObjects) {
    if (
      locationObject &&
      locationObject.jobPrice !== undefined &&
      locationObject.jobPrice !== ''
    ) {
      const price = Number(locationObject.jobPrice.replace(/[$,]/g, ''));
      subTotal += price;
    }
  }

  return subTotal;
};
export const calculateTax = (locations: LocationObject) => {
  let tax = 0;
  const locationObjects = Object.values(locations);

  for (const locationObject of locationObjects) {
    if (
      locationObject &&
      locationObject.tax !== undefined &&
      locationObject.tax !== ''
    ) {
      const price = Number(locationObject.tax.replace(/[$,]/g, ''));
      tax += price;
    }
  }
  return tax;
};
